<template>
  <tr>
    <th>소식 종류</th>
    <td>
      {{getNewsTypeText(newsType)}}
      <template
        v-if="newsType === 'CUSTOM'"
      >({{getCustomNewsText(customNewsType)}})</template>
    </td>
  </tr>
</template>

<script>
import newsMixin from "$views/News/_mixin";

export default {
  mixins: [newsMixin],
  props: {
    newsType: String,
    customNewsType: String
  }
};
</script>

<style>
</style>